<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'tryout/offline/index' }">
                                Tryout
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'tryout/offline/view', params: {id: tryout.id} }">
                                {{ tryout.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <h3>Tryout Offline {{ tryout.name }} - {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-9 col-sm-12">
                <div class="card shadow-sm mb-4 border-0" v-for="(question, index) in questions" v-bind:key="question.id">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Soal No. {{ question.order }}
                                </span>
                            </div>
                            <div class="col-auto" v-if="question.id && roleElligibleModified()">
                                <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="confirmationQuestion(question)">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card-title font-weight-bold mb-3" v-if="question.id">
                            <div class="row">
                                <div class="col-sm-auto col-12">
                                    Jawaban: {{ question.answer }}
                                </div>
                                <div class="col-sm-auto col-12 ml-md-auto">
                                    Persentase Siswa Benar: 
                                    <percentage v-bind:value="question.correctPercentage"></percentage>
                                </div>
                            </div>
                        </div>
                        <template v-if="question.solution">
                            <form v-on:submit.prevent="update($event, index)" disabled>
                                <div class="row justify-content-end mb-3">
                                    <div class="col font-weight-bold">
                                        Pembahasan 
                                    </div>
                                    <div class="ml-auto col-auto" v-if="roleElligibleModified()">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0 mr-2" v-on:click="toggleInput($event)">
                                                Edit
                                            </button>
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="confirmationSolution(question.solution)">
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="wrapper-input">
                                            <div class="form-group">
                                                <div class="row mb-4">
                                                    <div class="col">
                                                        <tinymce v-bind:id="'text-editor-solution-' + index" v-model="question.solution.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-end">
                                                    <div class="ml-auto col-auto">
                                                        <button type="submit" class="btn btn-danger btn-sm px-5">
                                                            Save
                                                        </button>
                                                        <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput">
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="toggle-input" v-html="question.solution.content"></div>
                                    </div>
                                </div>
                            </form>
                        </template>
                        <template v-else-if="question.id">
                            <form v-on:submit.prevent="add" disabled>
                                <div class="edit-action">
                                    <button class="btn btn-danger btn-sm px-3" type="button" v-on:click="form.solution = {questionID: question.id, content: ''}; toggleInput($event)">
                                        Buat Pembahasan
                                    </button>
                                </div>
                                <div class="wrapper-input">
                                    <div class="form-group">
                                        <div class="row mb-4">
                                            <div class="col">
                                                <tinymce v-bind:id="'text-editor-solution-' + index" v-model="form.solution.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row justify-content-end">
                                        <div class="ml-auto col-auto">
                                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-xl-9 col-sm-12 mb-4">
                <nav class="float-right">
                    <!-- Native Page Link -->
                    <ul class="pagination pagination-sm flex-wrap">
                        <li class="page-item" v-bind:class="{active: page === pageNumber}" v-for="pageNumber in pageCount">
                            <a v-bind:href="$router.resolve({name: 'tryout/offline/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id, page: pageNumber}}).href" class="page-link" tabindex="0">
                                {{ pageNumber }}
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <b-modal v-if="roleElligibleModified()" v-model="modal.question" v-on:hide="remove.question = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus soal ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="removeQuestion">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.question = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal v-if="roleElligibleModified()" v-model="modal.solution" v-on:hide="remove.solution = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus pembahasan soal ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="removeSolution">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.solution = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Paginate from 'vuejs-paginate';
    import tinymce from 'vue-tinymce-editor';
    import Percentage from "@/components/item/Percentage";
    import { tinyMCEOptions } from '@/params.js';

    /**
     * @param {Object} tryoutSubject
     */
    export default {
        name: "TryoutOfflineQuestionView",
        components: {
            Paginate,
            Percentage,
            tinymce
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    solution: {
                        content: '',
                        questionID: ''
                    }
                },
                tryout: {},
                tryoutSubject: {subject: {}},
                questions: [],
                modal: {
                    question: false,
                    solution: false
                },
                remove: {
                    question: null,
                    solution: null
                },
                pageCount: 0,
                page: 1,
                perPage: 5,
                tinyMCEOptions: tinyMCEOptions
            };
        },
        methods: {
            confirmationQuestion(model) {
                this.modal.question = true;
                this.remove.question = model;
            },
            confirmationSolution(model) {
                this.modal.solution = true;
                this.remove.solution = model;
            },
            removeQuestion() {
                this.axios.post(process.env.API_URL + '/question/delete/' + this.remove.question.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.paginate(this.page);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal.question = false;
                    this.remove.question = null;
                });
            },
            removeSolution() {
                this.axios.post(process.env.API_URL + '/solution/delete/' + this.remove.solution.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.paginate(this.page);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal.solution = false;
                    this.remove.solution = null;
                });
            },
            generateOrder(index) {
                return index + 1 + ((this.page - 1) * this.perPage);
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.paginate(this.page);
                    }
                } else {
                    this.paginate(this.page);
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            add(event) {
                this.axios.post(process.env.API_URL + '/solution', this.form.solution).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                        this.paginate(this.page);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            update(event, index) {
                let question = this.questions[index];
                if (question && question.solution) {
                    this.axios.post(process.env.API_URL + '/solution/update/' + question.solution.id, question.solution).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.toggleInput(event);
                            this.paginate(this.page);
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                }
            },
            paginate(page) {
                this.axios.get(process.env.API_URL + '/question', {params: {tryoutSubjectID: this.tryoutSubject.id, page: page, limit: this.perPage}}).then(response => {
                    let questions = [];
                    for (let i = 0; i < this.perPage; i++) {
                        let number = this.generateOrder(i);
                        if (number <= this.tryoutSubject.totalQuestion) {
                            questions.push(response.data.data.find(question => question.order === number) || {order: number, choices: []});
                        }
                    }
                    this.questions = questions;
                });
            },
            overrideTinyMCEOptions() {
                this.tinyMCEOptions = Object.assign({}, this.tinyMCEOptions, {
                    file_picker_callback: function (callback) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');
                        input.style.visibility = 'hidden';
                        input.style.position = 'absolute';

                        input.onchange = function () {
                            var file = input.files[0];
                            if (file) {
                                let formData = new FormData;
                                formData.set('image', file);
                                this.axios.post(process.env.API_URL + '/solution/uploadImage', formData).then(response => {
                                    if (response.data.status) {
                                        callback(response.data.location, {alt: file.name});
                                    }
                                });
                            }
                        }.bind(this);
                        input.click();
                    }.bind(this)
                });
            },
            roleElligibleModified() {
                return this.profile.isAdmin;
            }
        },
        created() {
            this.overrideTinyMCEOptions();
            this.page = parseInt(this.$route.params.page) || 1;
            this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.id).then(response => {
                this.tryout = response.data.data;
                if (this.tryout.tryoutOnline) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Tryout offline not found'}});
                }
                if (this.tryout.tryoutGroups.length) {
                    for (var i = 0; i < this.tryout.tryoutGroups.length; i++) {
                        this.tryoutSubject = this.tryout.tryoutGroups[i].tryoutSubjects.find(tryoutSubject => tryoutSubject.id === parseInt(this.$route.params.tryoutSubjectID));
                        if (this.tryoutSubject) {
                            break;
                        }
                    }
                } else {
                    this.tryoutSubject = this.tryout.tryoutSubjects.find(tryoutSubject => tryoutSubject.id === parseInt(this.$route.params.tryoutSubjectID));
                }
                if (!this.tryoutSubject) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Not found'}});
                }
                this.pageCount = Math.ceil(this.tryoutSubject.totalQuestion / this.perPage);

                this.paginate(this.page);
                document.title = 'Tryout Offline ' + this.tryout.name + ' - ' + this.tryoutSubject.subject.name + ' ' + this.tryoutSubject.code + ' - ' + process.env.APP_NAME;
            }).catch((error) => {
                this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
            });

        }
    };
</script>

<style scoped>
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }

    h1:empty, h2:empty, h3:empty, h4:empty, h5:empty, h6:empty,
    p:empty, .text-loading:empty, img:not([src]), img[src=""]{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/tryout/offline/question/View.vue